import { NodeSelection } from 'prosemirror-state';
import { checkIsPrintableKey } from '../../libs';
var cardSingleClick = function (_a) {
    var node = _a.node, nodePos = _a.nodePos, view = _a.view;
    if (node.type.spec.sylCard) {
        var _b = view.state, tr = _b.tr, doc = _b.doc, dispatch = view.dispatch;
        var newSelection = NodeSelection.create(doc, nodePos);
        dispatch(tr.setSelection(newSelection));
        return true;
    }
    return false;
};
var cardInput = function (_a) {
    var view = _a.view, event = _a.event;
    var tr = view.state.tr, dispatch = view.dispatch;
    // should delete Node when input with NodeSelection
    if (checkIsPrintableKey(event) && tr.selection instanceof NodeSelection) {
        dispatch(tr.deleteSelection());
    }
    return false;
};
export { cardInput, cardSingleClick };
//# sourceMappingURL=card.js.map